import './styles.scss'



export function NotFound() {
    return <div id="notfoundid">
        <div className="notfound">
            <div className="notfound-404">
                <h1>Oops!</h1>
                <h2>404 - Cтраницы не существует</h2>
            </div>
            <a href="/">На главную</a>
        </div>
    </div>
}